<template>
  <Modal v-model="status" title="扫码下载APP" :mask-closable="false" footer-hide>
    <img class="qr-code" src="@/assets/QRcode.png" alt />
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      status: false
    };
  },

  methods: {
    openDialog() {
      this.status = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.qr-code {
  display: block;
  margin: 0 auto;
}
</style>